import * as notify from "@/utils/notify";
export function parseJson(jsonString: string): any {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    notify.sendNotification('Error parsing JSON');
    return null;
  }
}